
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upcoming-auctions",
      function () {
        return require("private-next-pages/upcoming-auctions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upcoming-auctions"])
      });
    }
  